// extracted by mini-css-extract-plugin
export default {"componentBuilder":"styles_componentBuilder__mMS9t","buttonsContainer":"styles_buttonsContainer__Ie3ch","addressButtonsContainer":"styles_addressButtonsContainer__a-zwp"};